import { store } from '../../store'
import { httpgst, http } from '../../main'

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/expenses-company-status/' + store.state.userLogged.company[0].id + '/1'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  users ({commit, dispatch}, payload) {
    let url = 'api/petty-cash/users'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onUsers', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  projects ({commit, dispatch}, payload) {
    let url = 'api/projects/getProjects/' + store.state.userLogged.company[0].id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onProjects', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let expenses = payload.response.data.data
    payload.event.context.expenses = expenses
    payload.event.context.loadingItems = false
  },
  onUsers (state, payload) {
    let employees = payload.response.data.data
    payload.event.context.employees = employees
  },
  onProjects (state, payload) {
    let projects = payload.response.data.data
    let activeProjects = []
    if (projects && projects.length > 0) {
      activeProjects = projects.filter(project => project.status === 1)
    }
    payload.event.context.projects = activeProjects
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }

    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/advances.js